module.exports = __webpack_public_path__ + "static/generice-background-lg-52d509b288166c77457447fad36e0804.png";